<script setup lang="ts">import { ref as _ref } from 'vue';

import Modal from '@/components/Modal.vue'
import { Btn } from '@bagelink/vue'

const open = _ref(true)
</script>

<template>
	<Modal v-if="open" v-model:visible="open" width="600px" class="popupWrap">
		<div class="relative z-2 color-white txt-center my-4 pe-6 m_my-0 m_pe-0 m_-ms-1 m_-me-1">
			<img class="none m_block w-150px mx-auto -my-2" src="@/assets/popup1-mobile.png" alt="popup1">
			<p class="txt20">
				{{ $t("popup.stillUncertain") }}
			</p>
			<p class="txt40 playfair m_txt30">
				{{ $t("popup.weReHereToHelp") }}
			</p>
			<Btn outline color="primary" class="mt-1 round color-white m_px-075" @click="$emit('close')" to="/contact-us">
				{{ $t("popup.scheduleFreeConsultationToday") }}
			</Btn>
		</div>
		<img class="absolute inset-0 h-100p w-100p cover popupBg m_none" src="@/assets/popup1.jpg" alt="popup1">
	</Modal>
</template>

<style>
.popupBg {
    object-position: right;
}
</style>
